// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: relative;
  width: 80px;
  min-height: 100vh;
  flex-shrink: 0;
}
@media (max-width: 1200px) {
  .sidebar {
    width: 100%;
    min-height: auto;
  }
}
.sidebar__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  min-height: 100vh;
  background-color: #131313;
  box-shadow: var(--container-shadow);
  border-radius: 10px;
  padding: 16px;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  z-index: 100;
}
.sidebar__inner:hover {
  width: 315px;
}
.sidebar__inner:hover .sidebar__header span {
  opacity: 1;
  visibility: visible;
}
.sidebar__inner:hover .sidebar__text {
  opacity: 1;
  visibility: visible;
}
@media (max-width: 1200px) {
  .sidebar__inner {
    position: relative;
    width: 100%;
    min-height: auto;
    overflow: visible;
  }
  .sidebar__inner:hover {
    width: 100%;
  }
}
.sidebar__header {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  color: #fff;
  white-space: nowrap;
}
.sidebar__header span {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}
@media (max-width: 1200px) {
  .sidebar__header span {
    opacity: 1;
    visibility: visible;
  }
}
.sidebar__wrapper {
  padding: 0px;
}
.sidebar__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
@media (max-width: 1200px) {
  .sidebar__list {
    display: flex;
  }
}
@media (max-width: 768px) {
  .sidebar__list {
    flex-wrap: wrap;
  }
}
.sidebar__list-item {
  color: var(--accent-color);
  display: flex;
  align-items: center;
  transition: background 0.2s ease-in;
  padding: 8px 0;
  position: relative;
  width: 100%;
}
@media (max-width: 768px) {
  .sidebar__list-item {
    display: flex;
  }
}
.sidebar__list-item a {
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  color: #fff;
  white-space: nowrap;
}
.sidebar__list-item a.active {
  background: var(--primary-color);
}
.sidebar__list-item a:hover {
  background: var(--primary-color);
}
.sidebar__icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.sidebar__icon-wrapper svg {
  width: 24px;
  height: 24px;
  display: inline-block;
}
.sidebar__text {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}
@media (max-width: 1200px) {
  .sidebar__text {
    opacity: 1;
    visibility: visible;
  }
}
.sidebar__badge {
  position: absolute;
  top: -4px;
  right: -6px;
  background-color: #e53935;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  box-shadow: 0 2px 5px rgba(229, 57, 53, 0.4);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Sidebar/Sidebar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AADF;AAGE;EANF;IAOI,WAAA;IACA,gBAAA;EAAF;AACF;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEM;EACE,UAAA;EACA,mBAAA;AAAR;AAGM;EACE,UAAA;EACA,mBAAA;AADR;AAKI;EA5BF;IA6BI,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;EAFJ;EAII;IACE,WAAA;EAFN;AACF;AAME;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAJJ;AAMI;EACE,UAAA;EACA,kBAAA;EACA,iEAAA;AAJN;AAMM;EALF;IAMI,UAAA;IACA,mBAAA;EAHN;AACF;AAOE;EACE,YAAA;AALJ;AAQE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AANJ;AAQI;EALF;IAMI,aAAA;EALJ;AACF;AAMI;EARF;IASI,eAAA;EAHJ;AACF;AAME;EACE,0BCzFM;ED0FN,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAJJ;AAMI;EATF;IAUI,aAAA;EAHJ;AACF;AAKI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAHN;AAKM;EACE,gCCnHD;ADgHP;AAMM;EACE,gCCvHD;ADmHP;AASE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAPN;AAWE;EACE,UAAA;EACA,kBAAA;EACA,iEAAA;AATJ;AAWI;EALF;IAMI,UAAA;IACA,mBAAA;EARJ;AACF;AAWE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,4CAAA;EACA,UAAA;AATJ","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.sidebar {\r\n  position: relative;\r\n  width: 80px;\r\n  min-height: 100vh;\r\n  flex-shrink: 0;\r\n\r\n  @media (max-width: 1200px) {\r\n    width: 100%;\r\n    min-height: auto;\r\n  }\r\n\r\n  &__inner {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 80px;\r\n    min-height: 100vh;\r\n    background-color: #131313;\r\n    box-shadow: var(--container-shadow);\r\n    border-radius: 10px;\r\n    padding: 16px;\r\n    transition: width 0.3s ease-in-out;\r\n    overflow: hidden;\r\n    z-index: 100;\r\n\r\n    &:hover {\r\n      width: 315px;\r\n\r\n      .sidebar__header span {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n\r\n      .sidebar__text {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 1200px) {\r\n      position: relative;\r\n      width: 100%;\r\n      min-height: auto;\r\n      overflow: visible;\r\n\r\n      &:hover {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__header {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 20px 0;\r\n    color: #fff;\r\n    white-space: nowrap;\r\n\r\n    span {\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\r\n\r\n      @media (max-width: 1200px) {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__wrapper {\r\n    padding: 0px;\r\n  }\r\n\r\n  &__list {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    @media (max-width: 1200px) {\r\n      display: flex;\r\n    }\r\n    @media (max-width: 768px) {\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n\r\n  &__list-item {\r\n    color: $accent;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: background 0.2s ease-in;\r\n    padding: 8px 0;\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    @media (max-width: 768px) {\r\n      display: flex;\r\n    }\r\n\r\n    a {\r\n      width: 100%;\r\n      padding: 12px;\r\n      border-radius: 4px;\r\n      display: flex;\r\n      align-items: center;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      text-decoration: none;\r\n      color: #fff;\r\n      white-space: nowrap;\r\n\r\n      &.active {\r\n        background: $main;\r\n      }\r\n\r\n      &:hover {\r\n        background: $main;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__icon-wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 16px;\r\n    flex-shrink: 0;\r\n\r\n    svg {\r\n      width: 24px;\r\n      height: 24px;\r\n      display: inline-block;\r\n    }\r\n  }\r\n\r\n  &__text {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\r\n\r\n    @media (max-width: 1200px) {\r\n      opacity: 1;\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  &__badge {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -6px;\r\n    background-color: #e53935;\r\n    color: #ffffff;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    padding: 2px 4px;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 16px;\r\n    height: 16px;\r\n    box-shadow: 0 2px 5px rgba(229, 57, 53, 0.4);\r\n    z-index: 2;\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
